
import { GET_SODTODAY_LIST } from '../types/const.js';

let sodToDayList = null;

export default function sodtoday(state =  sodToDayList, action) {
  if  (action.type === GET_SODTODAY_LIST) {
    sodToDayList  = action.asodtoday;
    return   sodToDayList;
  } return state;
};



// WEBPACK FOOTER //
// ./src/client/reducers/sodtoday.js